import { Navigate } from "react-router";
import useChatbotConfig from "../hooks/useChatbotConfig";

const PrivateRouter = ({ children }) => {
  const { log } = useChatbotConfig();

  return log ? children : <Navigate to="/login" />;
};

export default PrivateRouter;
